import React from 'react';
import { FaInfoCircle, FaExclamationTriangle, FaCheckCircle } from 'react-icons/fa';

const DigitalProductFields = ({ formData, onChange }) => {
  return (
    <div className="mt-4">
      {/* Info Alert */}
      <div className="alert alert-info d-flex align-items-start" role="alert">
        <FaInfoCircle className="mr-2 mt-1" />
        <div>
          <strong>Digital Product Settings</strong>
          <p className="mb-0 mt-1" style={{ fontSize: '14px' }}>
            No shipping required • Payment is prepaid only (COD disabled) • Instant delivery after payment
          </p>
        </div>
      </div>

      {/* Download Limit */}
      <div className="form-group row mt-4">
        <label className="col-12 col-md-4 col-form-label">
          Download Limit <span className="text-danger">*</span>
        </label>
        <div className="col-12 col-md-8">
          <input
            type="number"
            min="1"
            max="100"
            value={formData.download_limit || 5}
            onChange={(e) => onChange('download_limit', parseInt(e.target.value) || 5)}
            className="form-control"
          />
          <small className="form-text text-muted">
            Number of times customer can download this file (1-100)
          </small>
        </div>
      </div>

      {/* Access Expiry Toggle */}
      <div className="form-group row">
        <label className="col-12 col-md-4 col-form-label">
          Access Expiry
        </label>
        <div className="col-12 col-md-8">
          <div className="custom-control custom-checkbox mb-3">
            <input
              type="checkbox"
              className="custom-control-input"
              id="has_expiry"
              checked={formData.has_expiry || false}
              onChange={(e) => {
                onChange('has_expiry', e.target.checked);
                if (!e.target.checked) {
                  onChange('access_expiry_days', null);
                }
              }}
            />
            <label className="custom-control-label" htmlFor="has_expiry">
              Set Access Expiry
            </label>
          </div>
          
          {formData.has_expiry ? (
            <div>
              <label className="mb-2">
                Access Expiry Days <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type="number"
                  min="1"
                  max="3650"
                  value={formData.access_expiry_days || 365}
                  onChange={(e) => onChange('access_expiry_days', parseInt(e.target.value) || 365)}
                  className="form-control"
                />
                <div className="input-group-append">
                  <span className="input-group-text">days</span>
                </div>
              </div>
              <small className="form-text text-muted">
                Number of days customer can access this file after purchase (1-3650)
              </small>
            </div>
          ) : (
            <div className="alert alert-success d-flex align-items-center" role="alert">
              <FaCheckCircle className="mr-2" />
              <span>Lifetime access (no expiry)</span>
            </div>
          )}
        </div>
      </div>

      {/* Prepaid Only Notice */}
      <div className="alert alert-warning d-flex align-items-start" role="alert">
        <FaExclamationTriangle className="mr-2 mt-1" />
        <div>
          <strong>Payment Method</strong>
          <p className="mb-0 mt-1" style={{ fontSize: '14px' }}>
            Prepaid only (COD not available for digital products)
          </p>
        </div>
      </div>

      {/* Digital Product Benefits */}
      <div className="card border-success">
        <div className="card-body" style={{ backgroundColor: '#d4edda' }}>
          <h6 className="card-title text-success mb-3">
            <FaCheckCircle className="mr-2" />
            Digital Product Benefits:
          </h6>
          <ul className="mb-0" style={{ fontSize: '14px', listStyle: 'none', paddingLeft: 0 }}>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ color: '#2E7D4F', marginRight: '8px', fontSize: '16px', lineHeight: '1.4' }}>✓</span>
              <span>Instant delivery to customers after payment</span>
            </li>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ color: '#2E7D4F', marginRight: '8px', fontSize: '16px', lineHeight: '1.4' }}>✓</span>
              <span>No shipping costs or logistics</span>
            </li>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ color: '#2E7D4F', marginRight: '8px', fontSize: '16px', lineHeight: '1.4' }}>✓</span>
              <span>Unlimited inventory (no stock management)</span>
            </li>
            <li style={{ marginBottom: '0', display: 'flex', alignItems: 'flex-start' }}>
              <span style={{ color: '#2E7D4F', marginRight: '8px', fontSize: '16px', lineHeight: '1.4' }}>✓</span>
              <span>Secure file storage and delivery</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DigitalProductFields;
